import { action } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { bind, inject } from '../../../../utils/decorators';
import Callout from '../../../site/Callout';
import { BpsReferenzkraftKalibrierungRili2021Store } from '../../../../stores/BpsReferenzkraftKalibrierungRili2021Store';
import { FormControl } from 'react-bootstrap';

/** Komponente zum Aktivieren der Justage für die Kalibrierung von Bremsprüfständen */
@observer
export default class BpsReferenzkraftJustageInfo extends React.Component<{}, {}> {

  @inject(BpsReferenzkraftKalibrierungRili2021Store) kalibrierungStore: BpsReferenzkraftKalibrierungRili2021Store;

  @bind @action handleJustageChange(ev: React.FormEvent<FormControl>) {
    this.kalibrierungStore.setJustageInfo((ev.target as HTMLInputElement).value);
  }

  render() {
    return (
      <Callout bsStyle="default">
        <h4>Justage</h4>
        <div className="text-hint-light">
          Bitte geben Sie hier an, ob im Rahmen der Kalibrierung eine Justage, Reparatur oder Neuinstallation durchgeführt wurde.
        </div>
        <FormControl componentClass="select" placeholder="select" onChange={this.handleJustageChange} value={this.kalibrierungStore.datensatz.justageInfo} disabled={this.kalibrierungStore.readOnly}>
          <option value={'keine'}>Nicht erforderlich</option>
          <option value={'justage'}>Durchgeführt</option>
          <option value={'reparatur'}>Reparatur/Instandsetzung durchgeführt</option>
          <option value={'neuinstallation'}>Neuinstallation</option>
        </FormControl>
      </Callout>);
  }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/vorlagen/bps/rili2021/BpsReferenzkraftJustageInfo.tsx